"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPaymentPlan = void 0;
const OrganizationConnectionBaseEntity_1 = require("../../entity/OrganizationConnectionBaseEntity");
// each record will have months number + day of each month OR a list of dates (schedule) to charge at
class ProductPaymentPlan extends OrganizationConnectionBaseEntity_1.OrganizationConnectionBaseEntity {
}
exports.ProductPaymentPlan = ProductPaymentPlan;
//# sourceMappingURL=ProductPaymentPlan.js.map